import React, { useState } from 'react'
import { Button, Container } from 'react-bootstrap'
import QuestionsImg from '../assets/images/connect-agent-cta-icon.svg'
import ContactAgentModal from './ContactAgentModal'
import {ASSETS_URL} from "../api/constants";

function ConnectAgentCTA({ data, section, loading }) {
  const [showContactModal, setShowContactModal] = useState(false);

  // Support both data and section props for backward compatibility
  const sectionData = section || data;
  
  // Default values
  const title = sectionData?.title || "Get help finding an agent";
  const subtitle = sectionData?.subtitle || "";
  const buttonText = sectionData?.btn_name || "Connect with an agent";
  const buttonLink = sectionData?.btn_link || "#";
  const icon = sectionData?.image || sectionData?.icon;

  const handleButtonClick = () => {
    if (buttonLink.startsWith('http://') || buttonLink.startsWith('https://')) {
      window.open(buttonLink, '_blank');
    } else {
      setShowContactModal(true);
    }
  };

  return (
    <>
      <div className="connect-agent-cta common-padding">
        <Container>
          <div className='connect-agent-cta-wrap'>
            <img src={icon ? `${ASSETS_URL}${icon}` : QuestionsImg} alt="" />
            <div className='text-wrap'>
              <h2>{title}</h2>
              <p>{subtitle}</p>
            </div>
            <Button
              className="custom-bttn style-3"
              onClick={handleButtonClick}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </div>
      <ContactAgentModal show={showContactModal} handleClose={() => setShowContactModal(false)} />
    </>
  );
}
export default ConnectAgentCTA